import LocomotiveScroll from "locomotive-scroll";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";



// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);
// LM Scroll

const scroll = new LocomotiveScroll({
  el: document.querySelector("[data-scroll-container]"),
  smooth: false,
});

// Nav menu mobile rwd

const btnMob = document.querySelector(".mobile-nav-btn");
const navMobActive = document.querySelector(".nav-mobil-on");

btnMob.addEventListener("click", function () {
  btnMob.classList.toggle("active");
  navMobActive.classList.toggle("active-nav-mob");
});

// Urgence nav header

const urgenceHead = document.querySelector("nav");

// scroll.on("scroll", (position) => {
//   if (position.scroll.y > 20) {
//     urgenceHead.classList.remove("onTop");
//   } else {
//     urgenceHead.classList.add("onTop");
//   }
// });

var lastScrollTop = 0;

window.addEventListener("scroll", function () {

  var st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > lastScrollTop) {
    urgenceHead.classList.remove("onTop");

  } else {
    urgenceHead.classList.add("onTop");
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
})

// Actus off cards

const checkNewsOff = document.querySelector(".newsOff__card__container");

const cardOff1 = document.querySelector(".js--newsOff1");
const cardOff2 = document.querySelector(".js--newsOff2");

const txtOff1 = document.querySelector(".js--newsOff--cardOff1");
const txtOff2 = document.querySelector(".js--newsOff--cardOff2");

const cardOn1 = document.querySelector(".js--newsOff--cardOpen1");
const cardOn2 = document.querySelector(".js--newsOff--cardOpen2");

const cardCta1 = document.querySelector(".js--newsOff--cta1 svg");
const cardCta2 = document.querySelector(".js--newsOff--cta2 svg");

const cardCtaText1 = document.querySelector(".js--newsOff--cta1 span");
const cardCtaText2 = document.querySelector(".js--newsOff--cta2 span");


if (checkNewsOff) {

  if (window.matchMedia("(min-width: 600px)").matches) {

    cardOff1.addEventListener("click", () => {
      if (cardCta1.classList.contains("ctaDown")) {
        cardCtaText1.innerHTML = 'Lire la suite';
        txtOff1.classList.remove("js--off");
        cardOn1.classList.remove("js--open");
        cardCta1.classList.remove("ctaDown");


        const openNews = gsap.timeline();

        openNews.to(cardOff1, {
          height: 380,
          duration: 0.4,
          ease: "elastic.inOut(1, 0.5)",
          onComplete: function () {
              scroll.scrollTo('#newsoff1Anchor', { 'offset': -300 });
          },
        });
      } else if (!cardCta1.classList.contains("ctaDown")) {

        const openNews = gsap.timeline();

        const heightPannel = cardOn1.scrollHeight;

        openNews.to(cardOff1, {
          height: heightPannel + 200,
          duration: 0.2,
          ease: "elastic.inOut(1, 0.5)",
          onComplete: function () {
            // cardOff1.classList.toggle('newsOff--open');
            txtOff1.classList.add("js--off");
            cardOn1.classList.add("js--open");
            cardCta1.classList.add("ctaDown");
            cardCtaText1.innerHTML = 'Réduire';
          },
        });
      }
    });

    cardOff2.addEventListener("click", () => {
      if (cardCta2.classList.contains("ctaDown")) {
        cardCtaText2.innerHTML = 'Lire la suite';
        txtOff2.classList.remove("js--off");
        cardOn2.classList.remove("js--open");
        cardCta2.classList.remove("ctaDown");
        const openNews = gsap.timeline();

        openNews.to(cardOff2, {
          height: 380,
          duration: 0.2,
          ease: "elastic.inOut(1, 0.5)",
          onComplete: function () {
            scroll.scrollTo('#newsoff2Anchor', { 'offset': -300 });
        },
        });
      } else if (!cardCta2.classList.contains("ctaDown")) {
        const openNews = gsap.timeline();

        const heightPannel = cardOn2.scrollHeight;

        openNews.to(cardOff2, {
          height: heightPannel + 200,
          duration: 0.2,
          ease: "elastic.inOut(1, 0.5)",
          onComplete: function () {
            // cardOff1.classList.toggle('newsOff--open');
            txtOff2.classList.add("js--off");
            cardOn2.classList.add("js--open");
            cardCta2.classList.add("ctaDown");
            cardCtaText2.innerHTML = 'Réduire';
          },
        });
      }
    });
  } else {

    // VERSION MOBILE !!! 

    cardOff1.addEventListener("click", () => {
      if (cardCta1.classList.contains("ctaDown")) {
        cardCtaText1.innerHTML = 'Lire la suite';
        txtOff1.classList.remove("js--off");
        cardOn1.classList.remove("js--open");
        cardCta1.classList.remove("ctaDown");

        const openNews = gsap.timeline();

        openNews.to(cardOff1, {
          height: 720,
          duration: 0.2,
          ease: "elastic.inOut(1, 0.5)",
          onComplete: function () {
            scroll.scrollTo('#newsoff1Anchor', { 'offset': -300 });
        },
        });
      } else if (!cardCta1.classList.contains("ctaDown")) {
        const openNews = gsap.timeline();

        const heightPannel = cardOn1.scrollHeight;

        openNews.to(cardOff1, {
          height: heightPannel + 480,
          duration: 0.2,
          ease: "elastic.inOut(1, 0.5)",
          onComplete: function () {
            // cardOff1.classList.toggle('newsOff--open');
            txtOff1.classList.add("js--off");
            cardOn1.classList.add("js--open");
            cardCta1.classList.add("ctaDown");
            cardCtaText1.innerHTML = 'Réduire';
          },
        });
      }
    });

    cardOff2.addEventListener("click", () => {
      if (cardCta2.classList.contains("ctaDown")) {
        cardCtaText2.innerHTML = 'Lire la suite';
        txtOff2.classList.remove("js--off");
        cardOn2.classList.remove("js--open");
        cardCta2.classList.remove("ctaDown");
        const openNews = gsap.timeline();

        openNews.to(cardOff2, {
          height: 720,
          duration: 0.2,
          ease: "elastic.inOut(1, 0.5)",
          onComplete: function () {
            scroll.scrollTo('#newsoff2Anchor', { 'offset': -300 });
        },
        });
      } else if (!cardCta2.classList.contains("ctaDown")) {
        const openNews = gsap.timeline();

        const heightPannel = cardOn2.scrollHeight;

        openNews.to(cardOff2, {
          height: heightPannel + 480,
          duration: 0.2,
          ease: "elastic.inOut(1, 0.5)",
          onComplete: function () {
            // cardOff1.classList.toggle('newsOff--open');
            txtOff2.classList.add("js--off");
            cardOn2.classList.add("js--open");
            cardCta2.classList.add("ctaDown");
            cardCtaText2.innerHTML = 'Réduire';
          },
        });
      }
    });
  }
}

///
// TEAM CARDS
///
const checkTeam = document.querySelector(".clinique__team__wrapper");

if (checkTeam) {

  const teamContainer = document.querySelector(".clinique__team__list");

  const btnDoc = document.querySelector(".btn--doc");
  const btnAsv = document.querySelector(".btn--asv");

  const cardsView = document.querySelectorAll(".team__card__container.onView");

  const teamDoc = document.querySelectorAll(".team__card__container.team--doc");
  const teamAsv = document.querySelectorAll(".team__card__container.team--asv");

  // Display Doc
  btnDoc.addEventListener("click", () => {
    if (
      !btnDoc.classList.contains("activBtn") &&
      btnAsv.classList.contains("activBtn")
    ) {
      btnDoc.classList.add("activBtn");
      btnAsv.classList.remove("activBtn");

      teamDoc.forEach((doc) => {
        const TLdoc = gsap.timeline();

        TLdoc.to(teamContainer, {
          opacity: 0,
          duration: 0.3,
          onComplete: function () {
            doc.classList.add("onView");
          },
        }).to(
          teamContainer,
          {
            opacity: 1,
            duration: 0.3,
          },
          "+=0.2"
        );
      });

      teamAsv.forEach((asv) => {
        const TLdoc = gsap.timeline();

        TLdoc.to(teamContainer, {
          opacity: 0,
          duration: 0.3,
          onComplete: function () {
            asv.classList.remove("onView");
          },
        }).to(
          teamContainer,
          {
            opacity: 1,
            duration: 0.3,
          },
          "+=0.2"
        );
      });
    } else if (btnDoc.classList.contains("activBtn")) {
      btnDoc.classList.remove("activBtn");

      teamAsv.forEach((asv) => {
        const TLdoc = gsap.timeline();

        TLdoc.to(teamContainer, {
          opacity: 0,
          duration: 0.3,
          onComplete: function () {
            asv.classList.add("onView");
          },
        }).to(
          teamContainer,
          {
            opacity: 1,
            duration: 0.3,
          },
          "+=0.2"
        );
      });
    } else if (!btnDoc.classList.contains("activBtn")) {
      btnDoc.classList.add("activBtn");
      btnAsv.classList.remove("activBtn");

      teamAsv.forEach((asv) => {
        const TLdoc = gsap.timeline();

        TLdoc.to(teamContainer, {
          opacity: 0,
          duration: 0.3,
          onComplete: function () {
            asv.classList.remove("onView");
          },
        }).to(
          teamContainer,
          {
            opacity: 1,
            duration: 0.3,
          },
          "+=0.2"
        );
      });
    }
  });

  // Display Asv
  btnAsv.addEventListener("click", () => {
    if (
      !btnAsv.classList.contains("activBtn") &&
      btnDoc.classList.contains("activBtn")
    ) {
      btnDoc.classList.remove("activBtn");
      btnAsv.classList.add("activBtn");

      teamAsv.forEach((asv) => {
        const TLdoc = gsap.timeline();

        TLdoc.to(teamContainer, {
          opacity: 0,
          duration: 0.3,
          onComplete: function () {
            asv.classList.add("onView");
          },
        }).to(
          teamContainer,
          {
            opacity: 1,
            duration: 0.3,
          },
          "+=0.2"
        );
      });

      teamDoc.forEach((doc) => {
        const TLdoc = gsap.timeline();

        TLdoc.to(teamContainer, {
          opacity: 0,
          duration: 0.3,
          onComplete: function () {
            doc.classList.remove("onView");
          },
        }).to(
          teamContainer,
          {
            opacity: 1,
            duration: 0.3,
          },
          "+=0.2"
        );
      });
    } else if (btnAsv.classList.contains("activBtn")) {
      btnAsv.classList.remove("activBtn");

      teamDoc.forEach((doc) => {
        const TLasv = gsap.timeline();

        TLasv.to(teamContainer, {
          opacity: 0,
          duration: 0.3,
          onComplete: function () {
            doc.classList.add("onView");
          },
        }).to(
          teamContainer,
          {
            opacity: 1,
            duration: 0.3,
          },
          "+=0.2"
        );
      });
    } else if (!btnAsv.classList.contains("activBtn")) {
      btnDoc.classList.remove("activBtn");
      btnAsv.classList.add("activBtn");

      teamDoc.forEach((doc) => {
        const TLasv = gsap.timeline();

        TLasv.to(teamContainer, {
          opacity: 0,
          duration: 0.3,
          onComplete: function () {
            doc.classList.remove("onView");
          },
        }).to(
          teamContainer,
          {
            opacity: 1,
            duration: 0.3,
          },
          "+=0.2"
        );
      });
    }
  });
}
////////////
// Valeurs horizontal scroll
////////////

const scrollSection = document.querySelector(".cliniqueValeurs");

if (scrollSection) {

  const scrollEls = scrollSection.querySelectorAll("span");

  gsap.to(scrollSection, {
    scrollTrigger: {
      trigger: scrollSection,
      scrub: 2,
    },
  });

  scrollEls.forEach((el) => {
    let scrollTl = gsap.timeline();
    scroll.x = -500;
    scrollTl.to(el, {
      xPercent: scroll.x,
      scrollTrigger: {
        trigger: scrollSection,
        scrub: 2,
        pin: false,
      },
    });
  });
}

///
// Services Pannel 
///

const pannelsBtn = document.querySelectorAll('.services__card__container');
const pannelWrapper = document.querySelector('.services__pannel--open');
const pannels = document.querySelectorAll('.services__pannel--content');
const pannelsBg = document.querySelectorAll('.pannel--open--bg');

const closeBtnPannel = document.querySelector('.closePannelBtn');

if (pannelWrapper) {

  pannelsBtn.forEach((btn) => {

    let pannelSpe = btn.id

    pannels.forEach((pannel) => {

      if (pannel.classList.contains(pannelSpe)) {

        btn.addEventListener("click", () => {

          pannel.classList.add('openPannel')
          pannelWrapper.classList.add('openPannel')

          const heightPannelOpen = pannel.scrollHeight;

          const TLPannels = gsap.timeline();

          TLPannels.to(pannel, {
            opacity: 1,
            duration: 0.3,
            height: heightPannelOpen,
            onComplete: function () {
              scroll.scrollTo('#anchorScroll', { 'offset': -180 });
            }
          })

          pannelsBg.forEach((bg) => {
            if (bg.classList.contains(pannelSpe)) {

              bg.classList.add('openPannel')

            } else if (!bg.classList.contains(pannelSpe)) {

              bg.classList.remove('openPannel')

            }
          })

        })

      } else if (!pannel.classList.contains(pannelSpe)) {

        btn.addEventListener("click", () => {

          pannel.classList.remove('openPannel')
          const heightPannelOpen = pannel.scrollHeight;
          // pannelWrapper.classList.remove('openPannel')
          const TLPannels = gsap.timeline();

          TLPannels.to(pannel, {
            opacity: 0,
            duration: 0.3,
            height: heightPannelOpen,
            duration: .3,
            onComplete: function () {
              scroll.scrollTo('#anchorScroll', { 'offset': -180 });
            }
          })
        })
      }
    })
  })

  closeBtnPannel.addEventListener('click', () => {

    pannels.forEach((pannel) => {
      const TLCLose = gsap.timeline();

      TLCLose.to(pannel, {
        height: 0,
        opacity: 0,
        duration: 0.3,
        onComplete: function () {
          pannelWrapper.classList.remove("openPannel");
        },
      })
    })
  })

}

///
// Actus layout filter 
///

function isotopeFullInit() {

  // init Isotope


  var $grid = $('.actus__content__wrapper').isotope({
    itemSelector: '.newsOn__card__container',
    transitionDuration: 400,
    stagger: 60,

    masonry: {
      gutter: 24
    }
  });


  // filter functions

  // bind filter button click
  let $filters = $('.actus__cat__track').on('click', 'a', function () {

    var $this = $(this);
    var filterValue;
    if ($this.is('.active-filter')) {
      // uncheck
      filterValue = '*';
    } else {
      filterValue = $this.attr('data-filter');
      $filters.find('.active-filter').removeClass('active-filter');
    }
    $this.toggleClass('active-filter');
    scroll.scrollTo('top', { 'offset': 100 });

    // use filterFn if matches value
    filterValue = filterValue;
    $grid.isotope({ filter: filterValue });

  });

}

const checkActus = document.querySelector('.actus__head');

if (checkActus) {
  isotopeFullInit();
}

// Exerp JS



// REFFERAL FORM 

const introStep = document.querySelector('.refferal__intro');
const btnIntro = document.querySelector('.ctaRefferal');

const refferalContainer = document.querySelector('.refferal__form__display');
const navRefferalForm = document.querySelector('.refferal__nav__container');
const RefferalFormCtn = document.querySelector('.refferal__form__container');

if(introStep){
  btnIntro.addEventListener("click", function () {
    introStep.classList.add('introLeave');
    refferalContainer.classList.add('enterForm');
    navRefferalForm.classList.add('navOpen');
    RefferalFormCtn.style.minHeight = "unset";
  })
}



